const routes = {
	// Main
	home: '/',
	// Auth
	login: '/login',
	/** Challenge for a browser this account has not been seen on before. */
	verifyDevice: '/verify-device',
	signup: '/signup',
	about: '/about',
	forgotPassword: '/forgot-password',
	resetPassword: '/reset-password',
	completeProfile: '/complete-profile',
	// User
	dashboard: '/dashboard',
	progress: '/progress',
	timeline: '/timeline',
	invoices: '/invoices',
	wallet: '/wallet',
	activity: '/activity',
	activityWallet: '/activity/wallet',
	account: '/account',
	accountDevices: '/account/devices',
	// Classroom
	classrooms: '/classrooms',
	classroom: '/classroom/:label',
	classroomOverview: '/classroom/:label',
	// Course (RELATIVE — nested under /classroom/:label)
	course: 'course/:cId',
	courseDetails: 'courses/:cId',
	// Standalone courses (top-level namespace — no collision with the
	// classroom-nested relatives above)
	coursesCatalog: '/courses',
	standaloneCourse: '/courses/:label',
	// Bundles (discounted groups of standalone courses)
	bundlesCatalog: '/bundles',
	bundle: '/bundles/:label',
	// Units
	videoUnit: 'video/:id',
	documentUnit: 'document/:id',
	webContentUit: 'webcontent/:id',
	webinarUnit: 'webinar/:id',
	// Test
	test: '/test/:id',
	// Instructor
	instructor: '/instructor/:label',
	// Others

	mcqUnit: 'test/:id',
	assignmentUnit: 'assignment/:id',
	results: '/results',
	search: '/search',
	paymentCallback: '/payment/callback',
	faqs: '/faqs',
	// Static pages (abwaab.com footer replicas)
	aboutUs: '/about-us',
	ourTeam: '/our-team',
	contactUs: '/contact-us',
	termsOfUse: '/terms-of-use',
	privacyPolicy: '/privacy-policy',
} as const

type Keys = keyof typeof routes
export type Route = (typeof routes)[Keys]

export default routes
